import { Grid } from '@material-ui/core';
import { AlertBar, Colors, Text } from 'library';
import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

interface IProps {
    open: boolean;
    onClose: () => void;
}

export default function InviteCopySuccessAlert({ open, onClose }: IProps) {
    return (
        <AlertBar open={open} onClose={onClose} variant="success">
            <Grid item>
                <Grid container>
                    <CheckCircleIcon style={{ paddingRight: 5, color: Colors.darkNavy }} />
                    <Text variant="body1">Your link has been copied.</Text>
                </Grid>
            </Grid>
            <div style={{ position: 'fixed', right: 20, cursor: 'pointer' }}>
                <CloseIcon onClick={onClose} style={{ color: Colors.darkNavy }} />
            </div>
        </AlertBar>
    );
}
